import { createContext } from "react";

const CreditManagementContext = createContext();

export default CreditManagementContext;